<div class="se-history-card" (click)="onCardSelected()" [class.se-card-selected]="item.selected">

    <div class="se-history-panel">
        <button mat-icon-button class="se-history-expansion-button se-button-no-ripple" *ngIf="!expanded && areDataInExpanderPresent(item)" (click)="expanded=true"
                [class.se-history-expansion-button-selected]="item.selected">
            <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <button mat-icon-button class="se-history-expansion-button se-button-no-ripple" *ngIf="expanded && areDataInExpanderPresent(item)" (click)="expanded=false"
                [class.se-history-expansion-button-selected]="item.selected">
            <mat-icon>keyboard_arrow_up</mat-icon>
        </button>
        <div style="display:flex;flex-direction:row" >
            <span class="se-history-label se-history-multi-value">{{'Date' | translate}}</span>
            <span class="se-history-label se-history-multi-value se-history-space" *ngIf="!!item.reportDateString">{{'ReportDate' | translate}}</span>
        </div>
        <div style="display:flex;flex-direction:row">
            <span class="se-history-value se-history-multi-value">{{item.dateString}}</span>
            <span class="se-history-value se-history-multi-value se-history-space" *ngIf="!!item.reportDateString">{{item.reportDateString}}</span>
        </div>
        <div style="display:flex;flex-direction:row">
            <span class="se-history-label se-history-multi-value" *ngIf="!!item.description">{{'Description' | translate}}</span>
            <span class="se-history-label se-history-multi-value se-history-space" *ngIf="!!item.status">{{'Status' | translate}}</span>
        </div>
        <div style="display:flex;flex-direction:row">
            <span class="se-history-value se-history-multi-value" *ngIf="!!item.description">{{item.description}}</span>
            <span class="se-history-value se-history-multi-value se-history-space" *ngIf="!!item.status">{{item.status}}</span>
        </div>
        <div [@expansionAnimation] *ngIf="!!expanded" class="se-history-expansion-panel">
            <div style="display:flex;flex-direction:row">
                <span class="se-history-label se-history-multi-value" *ngIf="!!item.provenance">{{'Provenance' | translate}}</span>
                <span class="se-history-label se-history-multi-value se-history-space" *ngIf="!!item.room">{{'Room' | translate}}</span>
            </div>
            <div style="display:flex;flex-direction:row">
                <span class="se-history-value se-history-multi-value" *ngIf="!!item.provenance">{{item.provenance}}</span>
                <span class="se-history-value se-history-multi-value se-history-space" *ngIf="!!item.room">{{item.room}}</span>
            </div>
            <div style="display:flex;flex-direction:row">
                <span class="se-history-label se-history-multi-value" *ngIf="!!item.businessUnit">{{'BusinessUnit' | translate}}</span>
                <span class="se-history-label se-history-multi-value se-history-space" *ngIf="!!item.archiveNumber">{{'ArchiveNumber' | translate}}</span>
            </div>
            <div style="display:flex;flex-direction:row">
                <span class="se-history-value se-history-multi-value" *ngIf="!!item.businessUnit">{{item.businessUnit}}</span>
                <span class="se-history-value se-history-multi-value se-history-space" *ngIf="!!item.archiveNumber">{{item.archiveNumber}}</span>
            </div>
            <div style="display:flex;flex-direction:row">
                <span class="se-history-label se-history-multi-value" *ngIf="!!item.admissionNumber">{{'AdmissionNumber' | translate}}</span>
                <span class="se-history-label se-history-multi-value se-history-space" *ngIf="!!item.externalAdmissionNumber">{{'ExternalAdmissionNumber' | translate}}</span>
            </div>
            <div style="display:flex;flex-direction:row">
                <span class="se-history-value se-history-multi-value" *ngIf="!!item.admissionNumber">{{item.admissionNumber}}</span>
                <span class="se-history-value se-history-multi-value se-history-space" *ngIf="!!item.externalAdmissionNumber">{{item.externalAdmissionNumber}}</span>
            </div>
        </div>
    </div> 
    <div class="se-history-footer-panel" [class.se-history-footer-selected-panel]="item.selected">

        <!-- Referto PDF -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="(item.reportDate && item.reportKey) ? 'block' : 'none'"
                (click)='openPdf($event)'>
            <mat-icon class="se-side-small-icon">picture_as_pdf</mat-icon>
        </button>
        <span class="se-history-footer-label" [style.display]="(item.reportDate && item.reportKey) ? 'block' : 'none'">PDF</span>

        <!-- Immagini -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="(item.imagesAvailability) ? 'block' : 'none'"
                (click)='openImagesByEprEvent($event)'>
            <mat-icon class="se-side-small-icon">collections</mat-icon>
        </button>
        <span class="se-history-footer-label" [style.display]="(item.imagesAvailability) ? 'block' : 'none'">{{'Images' | translate}}</span>

        <!-- Parametri Monitoraggio (H&S) -->
        <button mat-icon-button
                class="se-button-no-ripple"
                [style.display]="(item.isMonitoring) ? 'block' : 'none'"
                (click)='openParameters($event)'>
            <mat-icon class="se-side-small-icon">tune</mat-icon>
        </button>
        <span class="se-history-footer-label" [style.display]="(item.isMonitoring) ? 'block' : 'none'">{{'Parameters' | translate}}</span>
    </div>
</div>
